export var TimePeriod;
(function (TimePeriod) {
    TimePeriod["Today"] = "Today";
    TimePeriod["Yesterday"] = "Yesterday";
    TimePeriod["Last7Days"] = "Last 7 days";
    TimePeriod["Last4Weeks"] = "Last 4 weeks";
    TimePeriod["Last3Months"] = "Last 3 months";
    TimePeriod["Last12Months"] = "Last 12 months";
    TimePeriod["WeekToDate"] = "Week to date";
    TimePeriod["MonthToDate"] = "Month to date";
    TimePeriod["QuarterToDate"] = "Quarter to date";
    TimePeriod["YearToDate"] = "Year to date";
    TimePeriod["Total"] = "Total";
    TimePeriod["Custom"] = "Custom";
})(TimePeriod || (TimePeriod = {}));
//# sourceMappingURL=timePeriod.enum.js.map